export const GET_PRICING_INFO_REQUEST_SENT = 'GET_PRICING_INFO_REQUEST_SENT';
export const GET_PRICING_INFO_REQUEST_SUCCEEDED = 'GET_PRICING_INFO_REQUEST_SUCCEEDED';
export const GET_PRICING_INFO_REQUEST_FAILED = 'GET_PRICING_INFO_REQUEST_FAILED';

export const STORE_PRICING_INFO = 'STORE_PRICING_INFO';
